module.exports = __webpack_public_path__ + "img/ThreatManagementFacingImminentDanger.7b16b956.jpg";